import { z } from "zod";

// Aggregate stats for the currently filtered (or selected) set of invoices,
// shown in the invoices table command bar. Mirrors
// transactionsStatisticsResponseSchema, minus the cash in/out breakdown,
// which has no equivalent concept for invoices.
export const invoiceListStatisticsResponseSchema = z.object({
    count: z.number(),
    total: z.number(),
    average: z.number(),
});

export type InvoiceListStatistics = z.infer<
    typeof invoiceListStatisticsResponseSchema
>;
